export const AuthorCardList = (AuthorCardListSelector: HTMLDivElement) => {
  const authorCardListTrigger = AuthorCardListSelector.querySelector(
    '[data-author-card-list-trigger]'
  ) as HTMLButtonElement;

  const expandContent = () => {
    const hiddenElements = AuthorCardListSelector.querySelectorAll('.hidden');
    hiddenElements.forEach((element) => {
      element.classList.remove('hidden');
    });
  };

  const hideTriggerButton = () => {
    authorCardListTrigger.remove();
  };

  if (authorCardListTrigger) {
    authorCardListTrigger.addEventListener('click', (e: Event) => {
      e.preventDefault();
      expandContent();
      hideTriggerButton();
    });
  }
};

export default AuthorCardList;
